import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styles from './plans.module.scss'
import Button from './button'
import Billing from './billing'

class Plans extends React.Component {
  state = { billing: 'monthly' }

  handleChangeBilling = (billing) => {
    this.setState({ billing })
  }

  getQueryStringParams = (query) => {
    return query
      ? (/^[?#]/.test(query) ? query.slice(1) : query)
          .split('&')
          .reduce((params, param) => {
            let [key, value] = param.split('=')
            params[key] = value
              ? decodeURIComponent(value.replace(/\+/g, ' '))
              : ''
            return params
          }, {})
      : {}
  }

  componentDidMount = () => {
    const userDataExists =
      window.location.search &&
      window.location.search !== '' &&
      this.getQueryStringParams(window.location.search).userid &&
      this.getQueryStringParams(window.location.search).email

    if (userDataExists) {
      window.sessionStorage.setItem(
        'user',
        JSON.stringify({
          userid: this.getQueryStringParams(window.location.search).userid,
          email: this.getQueryStringParams(window.location.search).email,
        })
      )

      this.setState({ userExists: true })
    } else if (window.sessionStorage.getItem('user')) {
      this.setState({ userExists: true })
    }
  }

  createLink = (productId) => {
    const billing = this.state.billing === 'yearly' ? '-year' : ''
    const tryLink = `https://play.gymradio.com/subscribe/gymradio-${productId}${billing}`
    const buyLink = `https://gymix.eu.recurly.com/subscribe/gymradio-pro${billing}`

    const finalLink = () => {
      if (productId === 'free') return 'https://play.gymradio.com/'
      return userDataExists() ? buyLink + userData() : tryLink
    }

    const getUserData = () => JSON.parse(window.sessionStorage.getItem('user'))

    const userDataExists = () =>
      typeof window !== `undefined` && window.sessionStorage.getItem('user')

    const userData = () => `/${getUserData().userid}/${getUserData().email}`

    return finalLink()
  }

  handleCreateLink = (node) => {
    if (
      node.name?.toLowerCase() !== 'free trial' &&
      node.name.toLowerCase() !== 'enterprise'
    ) {
      return this.createLink(node.name.toLowerCase())
    } else if (node.name.toLowerCase() === 'free trial') {
      if (!this.state.userExists) return `https://play.gymradio.com`
      else return ''
    }
  }

  render() {
    const data = this.props.data
    console.log(data)
    const SvgSymbols = () => (
      <svg xmlns="http://www.w3.org/2000/svg">
        <symbol viewBox="-285 408.9 24 24" id="plans-yes">
          <g fill="currentColor">
            <path
              opacity="0.3"
              d="M-273,408.9c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S-266.4,408.9-273,408.9z M-273,430.9c-5.5,0-10-4.5-10-10
      c0-5.5,4.5-10,10-10s10,4.5,10,10C-263,426.4-267.5,430.9-273,430.9z"
            />
            <polygon points="-274.3,422.6 -277.4,419.7 -278.8,421.1 -274.2,425.4 -266.8,417.8 -268.2,416.4 	" />
          </g>
        </symbol>
        <symbol viewBox="0 0 24 24" id="plans-no">
          <path
            opacity="0.3"
            fill="currentColor"
            d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 15.538l-3.592-3.548 3.546-3.587-1.416-1.403-3.545 3.589-3.588-3.543-1.405 1.405 3.593 3.552-3.547 3.592 1.405 1.405 3.555-3.596 3.591 3.55 1.403-1.416z"
          />
        </symbol>
        <symbol viewBox="-12 -3 24 24" id="premium-plans">
          <circle cx="0" cy="9" r="12" fill="currentColor" />
          <polygon
            fill="#FFFFFF"
            points="1.1,5 -1.1,5 -1.1,7.9 -4,7.9 -4,10.1 -1.1,10.1 -1.1,13 1.1,13 1.1,10.1 4,10.1 4,7.9 1.1,7.9
      "
          />
        </symbol>
      </svg>
    )

    const Yes = () => (
      <svg>
        <use xlinkHref="#plans-yes" />
      </svg>
    )
    const No = () => (
      <svg>
        <use xlinkHref="#plans-no" />
      </svg>
    )

    return (
      <>
        {/* <Billing
          changeBilling={(billing) => this.handleChangeBilling(billing)}
          currentBilling={this.state.billing}
        /> */}

        <div className={styles.plans}>
          <div className={styles.plans__icons}>
            <SvgSymbols />
          </div>

          {data.map(({ node }) => (
            <article
              key={node.id}
              className={`${styles.plans__item} ${
                node.isRecommended ? styles.plans__itemPro : ''
              }`}
            >
              <div className={styles.plans__wrapper}>
                <header className={styles.plans__header}>
                  <h3 className={styles.plans__title}>{node.name}</h3>
                  <p className={styles.plans__description}>
                    {node.description}
                  </p>
                  {node.isRecommended && (
                    <span className={styles.plans__recommended}>
                      Recommended
                    </span>
                  )}
                </header>
                {node.price.length > 0 && (
                  <div className={styles.plans__price}>
                    <p>
                      {node.price[0].prependText}{' '}
                      <strong>
                        {node.name === 'PRO MONTHLY' && node.price[0].monthlyPrice}
                      </strong>{' '}
                      {node.price[0].appendText}
                    </p>
                  </div>
                )}
              </div>
              <div className={styles.plans__content}>
                {node.premiumFeatures.length > 0 && (
                  <ul
                    className={
                      styles.plans__list + ' ' + styles['plans__listPremium']
                    }
                  >
                    {node.premiumFeatures.map((f, key) => (
                      <li key={key}>
                        <svg>
                          <use xlinkHref="#premium-plans" />
                        </svg>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: f.text,
                          }}
                        />
                      </li>
                    ))}
                  </ul>
                )}

                {node.features.length > 0 && (
                  <ul className={styles.plans__list}>
                    {node.features.map((f, key) => (
                      <li key={key}>
                        {f.trueOrFalse ? <Yes /> : <No />}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: f.text,
                          }}
                        />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <footer className={styles.plans__footer}>
                <Button
                  href={this.handleCreateLink(node)}
                  onClick={() => {
                    if (
                      node.name.toLowerCase() === 'enterprise' &&
                      window.HubSpotConversations
                    ) {
                      window.HubSpotConversations.widget.open();
                    }
                  }}
                  variant={
                    node.isRecommended ? 'secondary' : 'outline_secondary'
                  }
                >
                  {this.state.userExists
                    ? node.buttonTextExistingUser
                    : node.buttonText}
                </Button>
                {node.note && node.note !== '' && !this.state.userExists && (
                  <div
                    className={styles.plans__note}
                    dangerouslySetInnerHTML={{
                      __html: node.note,
                    }}
                  />
                )}
              </footer>
            </article>
          ))}
        </div>
      </>
    )
  }
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        allDatoCmsPricingPlan(sort: { fields: position, order: ASC }) {
          edges {
            node {
              id
              name
              position
              description
              features {
                text
                trueOrFalse
              }
              premiumFeatures {
                text
                trueOrFalse
              }
              buttonText
              buttonTextExistingUser
              note
              isRecommended
              price {
                monthlyPrice
                yearlyPrice
                prependText
                appendText
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <Plans data={data.allDatoCmsPricingPlan.edges} {...props} />
    )}
  />
)
